module.exports = __webpack_public_path__ + "img/logo2.85d73488.png";